import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import { computeUserRank, ranks } from 'helpers/UserRank';

import ProgressBar from './components/ProgressBar';
import UserRankSteps from './components/UserRankSteps';

import styles from './Onboarding.module.scss';

const Onboarding = ({ user, innerRef }) => {
  const location = useLocation();
  const currentRank = computeUserRank(user);

  // Check if we're on a Portfolio page (matches /:username/:option? pattern)
  const isPortfolioPage =
    location.pathname !== '/' &&
    /^\/[A-Za-z0-9_]{1,20}(\/.*)?$/.test(location.pathname) &&
    !location.pathname.startsWith('/jobs') &&
    !location.pathname.startsWith('/projects') &&
    !location.pathname.startsWith('/browse') &&
    !location.pathname.startsWith('/onboarding') &&
    !location.pathname.startsWith('/notifications') &&
    !location.pathname.startsWith('/manage') &&
    !location.pathname.startsWith('/messages') &&
    !location.pathname.startsWith('/report') &&
    !location.pathname.startsWith('/saved-jobs') &&
    !location.pathname.startsWith('/shortlist') &&
    !location.pathname.startsWith('/settings') &&
    !location.pathname.startsWith('/payments') &&
    !location.pathname.startsWith('/earnings') &&
    !location.pathname.startsWith('/post') &&
    !location.pathname.startsWith('/pricing');

  const bannerClasses = [
    styles.onboardingBanner,
    isPortfolioPage ? styles.onboardingBannerPortfolio : '',
  ]
    .filter(Boolean)
    .join(' ');

  return currentRank !== ranks.INVALID_RANK &&
    currentRank !== ranks.MAX_RANK ? (
    <Col id="static-banner" className={bannerClasses}>
      <div className={styles.onboardingBannerContainer}>
        <div className={styles.onboardingBannerContainerInner}>
          <Row className={styles.rankBannerContainer}>
            <Col xs={12} md={8} className={styles.rankBannerContainer}>
              <ProgressBar user={user} />

              <UserRankSteps user={user} currentRank={currentRank} />
            </Col>
          </Row>
        </div>
      </div>
    </Col>
  ) : (
    <span />
  );
};

Onboarding.propTypes = {
  user: PropTypes.object,
};

export default connect(
  (state) => ({
    user: state.auth.user,
  }),
  {
    //
  },
  null,
  { forwardRef: true }
)(Onboarding);
